export type JotformBlockClassNames = Partial<{
  block: string
  inview: string
  inner: string
  header: string
  label: string
  title: string
  intro: string
  content: string
}>

export type JotFormsBlockState = { }

export const initialJotFormsBlockState: JotFormsBlockState = { }